/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./uploader-bar.vue?vue&type=template&id=1c055c0d&scoped=true&"
import script from "./uploader-bar.vue?vue&type=script&lang=ts&"
export * from "./uploader-bar.vue?vue&type=script&lang=ts&"
import style0 from "./uploader-bar.vue?vue&type=style&index=0&id=1c055c0d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c055c0d",
  null
  
)

export default component.exports